var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_Set.js
// module id = 3975
// module chunks = 168707334958949